/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_Join_FailedInputs */



/**
* | output |
* | --- |
* | "We could not add you to the workspace. Try again, or ask the person who invited you for a new invitation." |
*
* @param {Invite_X15_Join_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const invite_x15_join_failed = /** @type {((inputs?: Invite_X15_Join_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_Join_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("We could not add you to the workspace. Try again, or ask the person who invited you for a new invitation.")
});